import {useTranslations} from 'next-intl';

const usePrivacyNoticeTabItems = () => {
  const t = useTranslations('legal.tabs.privacyNotice');

  return [
    {
      text: t('privacyPolicy'),
      value: 'privacy-policy',
      child: false,
      routerPushUrl: '/privacy'
    },
    {
      text: t('candidatesPolicy'),
      value: 'candidates-policy',
      child: false,
      routerPushUrl: '/candidate-privacy'
    },
    {
      text: t('cookiesPolicy'),
      value: 'cookies-policy',
      child: false,
      routerPushUrl: '/cookies'
    },
    {
      text: t('notSellInformation'),
      value: 'not-sell-information',
      child: false,
      routerPushUrl: '/workable-data-selling-CCPA-policy'
    },
    {
      text: t('recruitmentPrivacyTemplate'),
      value: 'recruitment-privacy-template',
      child: false,
      routerPushUrl: '/candidate-terms'
    }
  ];
};

export default usePrivacyNoticeTabItems;
